import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { investorAuthService } from '../utils/investorAuth';

interface InvestorProtectedRouteProps {
  children: React.ReactNode;
}

export default function InvestorProtectedRoute({ children }: InvestorProtectedRouteProps) {
  const [isLoading, setIsLoading] = useState(true);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const location = useLocation();

  useEffect(() => {
    let isMounted = true;

    const checkAuth = async () => {
      try {
        // ✅ التحقق السريع من وجود التوكن أولاً
        const token = investorAuthService.getToken();
        
        if (!token) {
          console.log('❌ لا يوجد توكن');
          if (isMounted) {
            setIsAuthenticated(false);
            setIsLoading(false);
          }
          return;
        }

        console.log('✅ يوجد توكن، جاري التحقق من الجلسة...');

        // ✅ التحقق من صحة الجلسة
        const result = await investorAuthService.verifySession();
        
        console.log('نتيجة التحقق:', result);

        if (isMounted) {
          setIsAuthenticated(result.success);
          setIsLoading(false);
        }
      } catch (error) {
        console.error('❌ خطأ في التحقق من المصادقة:', error);
        if (isMounted) {
          setIsAuthenticated(false);
          setIsLoading(false);
        }
      }
    };

    checkAuth();

    return () => {
      isMounted = false;
    };
  }, [location.pathname]); // ✅ إعادة التحقق عند تغيير الصفحة

  if (isLoading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-[#f9bf4b] to-[#e5ab37] flex items-center justify-center" dir="rtl">
        <div className="text-center">
          <div className="inline-block animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-[#0c343d] mb-4"></div>
          <p className="text-[#0c343d] text-lg font-semibold">جاري التحقق من الجلسة...</p>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    console.log('❌ غير مصادق، إعادة التوجيه لصفحة تسجيل الدخول');
    return <Navigate to="/investor/login" replace />;
  }

  console.log('✅ مصادق بنجاح، عرض المحتوى');
  return <>{children}</>;
}